// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-summary .v-data-table>.v-data-table__wrapper>table>tbody>tr:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;
